import { InjectionToken } from '@angular/core';

export type ChatProvider = '247' | 'liveperson' | 'sierra';

/**
 * @deprecated Use CHAT_PROVIDER_INSTANCE from de-care/libs/inventory/utility-code/angular/configuration-token-chat-provider-instance/src/lib/tokens.ts
 */
export const ChatProviderToken = new InjectionToken<ChatProvider>(
    'chatProvider',
    {
        providedIn: 'root',
        factory: () => 'liveperson',
    },
);
